// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__2cBS2","row":"styles_row__12IMp"};